var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"note"},[_c('button',{on:{"click":_vm.goBack}},[_vm._v("\n    Go Back\n  ")]),(_vm.camshow)?_c('div',{attrs:{"id":"cam"}},[_c('camNote',{ref:"camnote"})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }